/* RESPONSIBLE TEAM: team-standalone */

import { ChannelTargetingBodyData } from '../definitions';

export default class HubspotChannelTargetingBodyData extends ChannelTargetingBodyData {
  get addMessengerChannel() {
    return true;
  }

  get channelGroupTitleKey() {
    return 'operator.workflows.channels.groupings.hubspot';
  }

  get channels() {
    return [];
  }
}
